import { compact, uniq } from "lodash";
import { DateTime } from "luxon";
import randomBytes from "randombytes";
import { REGEX_NON_ALPHANUMERIC } from "./regex";
import { Timezone } from "./timezone";
export const toJSON = (obj) => {
    try {
        return JSON.parse(JSON.stringify(obj));
    }
    catch (error) {
        console.error(error);
        return {};
    }
};
export const unique = (array) => {
    return uniq(compact(array));
};
export const walletAddressPreview = (address) => {
    if (!address)
        return "";
    return `${address.substring(0, 8)}...${address.slice(address.length - 5)}`;
};
export const API_RETRY_HEADER = "MOONGATE-RETRY";
export const intToHex = (int) => {
    return `0x${int.toString(16)}`;
};
export const hexToInt = (hex) => {
    return parseInt(hex, 16);
};
export const toDuration = (start, end, timezone) => {
    if (start == 0 && end == 9999999999999)
        return "Forever";
    const startDate = DateTime.fromMillis(start, { zone: timezone });
    const endDate = DateTime.fromMillis(end, { zone: timezone });
    const startStr = start == 0 ? "Now" : startDate.toFormat("d MMM yy, HH:mm");
    if (start == end)
        return startStr + (start > 0 ? ` (${startDate.offsetNameShort})` : "");
    const endStr = end == 9999999999999
        ? "Forever"
        : endDate.hasSame(startDate, "day")
            ? endDate.toFormat("HH:mm")
            : endDate.toFormat("d MMM yy, HH:mm");
    return `${startStr} - ${endStr} (${startDate.offsetNameShort})`;
};
export const formatDate = (timestamp, timezone = Timezone["Asia/Hong_Kong"], format = "d MMM yy, HH:mm") => {
    const date = DateTime.fromMillis(timestamp, { zone: timezone });
    return date.toFormat(format);
};
export const cryptoId = (length = 16) => {
    return randomBytes(length).toString("hex");
};
export const toSearchText = (text) => {
    return (text || "")
        .toLowerCase()
        .replace(REGEX_NON_ALPHANUMERIC, "")
        .replace(/\s+/g, "");
};
export const toSlug = (text) => {
    return (text || "")
        .replace(/[^a-z\d\s\-]/gi, "")
        .toLowerCase()
        .replace(/\s/g, "-")
        .trim();
};
export const compareText = (t1, t2) => {
    return (t1 || "").trim().toLowerCase() === (t2 || "").trim().toLowerCase();
};
export const normalizeEmail = (email) => {
    try {
        return email.trim().toLowerCase().replace(/\+.*@/, "@");
    }
    catch (error) {
        return email;
    }
};
